// extracted by mini-css-extract-plugin
export default {"list":"about-you_list__5C3N8","subtitle":"about-you_subtitle__ItNXF","container_advantages":"about-you_container_advantages__fLG1V"};